import React from 'react';
import { Form, Input, Button, Row, Col, Select } from 'antd';
import { WCPallet } from '../../types/wordpress';
import { UnitDimension } from '../../enums/calculator';
import { decodeHtmlEntities } from 'utils/helpers';

interface PalletFormProps {
    initialValues?: WCPallet | null;
    onSubmit: (values: Partial<WCPallet>) => void;
    onCancel: () => void;
}

const PalletForm: React.FC<PalletFormProps> = ({ initialValues, onSubmit, onCancel }) => {
    const [form] = Form.useForm();
    console.log(initialValues);
    const decodedInitialValues = initialValues ? {
        ...initialValues,
        title: decodeHtmlEntities(initialValues.title?.rendered ?? '')
    } : {
        unitType: UnitDimension.INCH
    };

    return (
        <Form
            form={form}
            layout="vertical"
            initialValues={decodedInitialValues}
            onFinish={onSubmit}
        >
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                        name="title"
                        label="Pallet Name"
                        rules={[{ required: true, message: 'Please enter pallet name' }]}

                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                        name="unitType"
                        label="Unit Type"
                        rules={[{ required: true, message: 'Please select unit type' }]}
                    >
                        <Select>
                            <Select.Option value={UnitDimension.INCH}>Inches</Select.Option>
                            <Select.Option value={UnitDimension.CM}>Centimeters</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item
                        name="width"
                        label="Width"
                        rules={[{ required: true, message: 'Please enter width' }]}
                    >
                        <Input type="number" step="0.01" min="0" />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        name="length"
                        label="Length"
                        rules={[{ required: true, message: 'Please enter length' }]}
                    >
                        <Input type="number" step="0.01" min="0" />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        name="height"
                        label="Height"
                        rules={[{ required: true, message: 'Please enter height' }]}
                    >
                        <Input type="number" step="0.01" min="0" />
                    </Form.Item>
                </Col>
            </Row>



            <Form.Item>
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={onCancel} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit">
                        {initialValues ? 'Update' : 'Create'} Pallet
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
};

export default PalletForm; 